import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import { RouteComponentProps, withRouter } from 'react-router';
import { State } from '../../../store/state';
import { connect } from 'react-redux';
import { useTranslation, Trans } from 'react-i18next';
import { PageLayout, Preloader } from '@epicode/react-inspinia';
import classNames from 'classnames';
import styles from './JobOfferApplicationSent.module.scss';
import logo from './logo-epicode.png';
import { ThunkDispatch } from '../../../api/_commons/thunks.common';
import { JobOffersThunks } from '../../../api/jobOffers/jobOffers.thunk';

interface OfferApplicationSentProps {
    jobTitle: string;
}

const OfferApplicationSent = (props: OfferApplicationSentProps) => {
    const { t } = useTranslation();
    const positionName = props.jobTitle;

    return (
        <>
            <Helmet>
                <title>ATS - {props.jobTitle}</title>
            </Helmet>
            <PageLayout>
                <div className={classNames('animated fadeInDown', styles.container)}>
                    <div className={styles.logo}>
                        <img src={logo} alt='Epicode' />
                    </div>
                    <h1 className={styles.title}>{t('jobApplication.sentTitle')}</h1>
                    <p className={styles.message}>
                        <Trans
                            i18nKey={'jobApplication.sentMessage'}
                            tOptions={{
                                positionName
                            }}>
                            Your application has been successfully submitted for the <strong>{{ positionName }}</strong>{' '}
                            position at <strong>Epicode</strong>.
                        </Trans>
                    </p>
                    <p className={styles.messageSmall}>{t('jobApplication.sentMessage2')}</p>
                </div>
            </PageLayout>
        </>
    );
};

interface OfferApplicationSentContainerStateProps {
    jobTitle: string;
    isLoading: boolean;
}

interface OfferApplicationSentContainerDispatchProps {
    fetchJobDetails: () => void;
}

interface OfferApplicationSentContainerRouteProps {
    id: string;
}

const OfferApplicationSentContainer = (
    props: OfferApplicationSentContainerStateProps &
        OfferApplicationSentContainerDispatchProps &
        RouteComponentProps<OfferApplicationSentContainerRouteProps>
) => {
    useEffect(() => {
        // if recruitment data is not loaded then load it now
        // this can happen if we navigate directly to this page or refresh it
        if (!props.jobTitle) {
            props.fetchJobDetails();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (props.isLoading) {
        return <Preloader overlay />;
    }

    return <OfferApplicationSent jobTitle={props.jobTitle} />;
};

const mapStateToProps = (
    state: State,
    props: RouteComponentProps<OfferApplicationSentContainerRouteProps>
): OfferApplicationSentContainerStateProps => ({
    jobTitle:
        (state.jobOffers.items[props.match.params.id] && state.jobOffers.items[props.match.params.id].jobTitle) || '',
    isLoading: state.jobOffers.isLoading
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch,
    props: RouteComponentProps<OfferApplicationSentContainerRouteProps>
): OfferApplicationSentContainerDispatchProps => ({
    fetchJobDetails: () => dispatch(JobOffersThunks.getJobOffer(props.match.params.id))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OfferApplicationSentContainer));
